function byNodeName(name) {
  return node => node.nodeName === name;
}

function findChild(node, name) {
  return Array.from(node.childNodes).find(byNodeName(name));
}

function filterChildren(node, name) {
  return Array.from(node.childNodes).filter(byNodeName(name));
}

function parseTrack(track) {
  const name = findChild(track, 'name');
  const points = [];
  const segments = filterChildren(track, 'trkseg');
  segments.forEach(seg => {
    const pts = filterChildren(seg, 'trkpt');
    pts.forEach(pt => {
      points.push({
        lng: Number(pt.attributes.lon.nodeValue),
        lat: Number(pt.attributes.lat.nodeValue),
      });
    });
  });
  return {
    title: name ? name.innerHTML : '',
    points,
  };
}

function parseRoute(route) {
  const name = findChild(route, 'name');
  const points = [];
  const waypoints = [];
  const wpts = filterChildren(route, 'rtept');
  wpts.forEach(wpt => {
    points.push({
      lng: Number(wpt.attributes.lon.nodeValue),
      lat: Number(wpt.attributes.lat.nodeValue),
    });
    const pts = wpt.querySelectorAll('rpt');
    Array.from(pts).forEach(pt => {
      points.push({
        lng: Number(pt.attributes.lon.nodeValue),
        lat: Number(pt.attributes.lat.nodeValue),
      });
    });
    waypoints.push(points.length);
  });
  return {
    title: name ? name.innerHTML : '',
    points,
    waypoints: waypoints.slice(0, -1).join(','),
  };
}

function parseGpx(content) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, 'application/xml');
  if (doc.documentElement.nodeName !== 'gpx') {
    throw new Error('noGpx');
  }
  const track = findChild(doc.documentElement, 'trk');
  if (track) {
    return parseTrack(track);
  }
  const route = findChild(doc.documentElement, 'rte');
  if (route) {
    return parseRoute(route);
  }
  throw new Error('No Tracks or Routes');
}

export default parseGpx;
